import { Controller } from "@hotwired/stimulus"

// Handles file selection display for the contract upload dropzone.
// Shows the selected filename and reveals the notes + submit section.
export default class extends Controller {
  static targets = ["fileName", "details"]

  fileSelected(event) {
    const input = event.target
    if (!input.files || input.files.length === 0) return

    const file = input.files[0]
    if (this.hasFileNameTarget) {
      this.fileNameTarget.textContent = file.name
      this.fileNameTarget.classList.remove("hidden")
    }
    if (this.hasDetailsTarget) {
      this.detailsTarget.classList.remove("hidden")
    }
  }
}
